import Vue from 'vue';
export default Vue.extend({
    name: 'BuddyFaq',
    computed: {
        accordions() {
            return [
                {
                    title: this.$t('buddyPage.faq.a1.title'),
                    content: this.$t('buddyPage.faq.a1.content')
                },
                {
                    title: this.$t('buddyPage.faq.a2.title'),
                    content: this.$t('buddyPage.faq.a2.content')
                },
                {
                    title: this.$t('buddyPage.faq.a3.title'),
                    content: this.$t('buddyPage.faq.a3.content')
                },
                {
                    title: this.$t('buddyPage.faq.a4.title'),
                    content: this.$t('buddyPage.faq.a4.content')
                },
                {
                    title: this.$t('buddyPage.faq.a5.title'),
                    content: this.$t('buddyPage.faq.a5.content')
                },
                {
                    title: this.$t('buddyPage.faq.a6.title'),
                    content: this.$t('buddyPage.faq.a6.content')
                },
                {
                    title: this.$t('buddyPage.faq.a7.title'),
                    content: this.$t('buddyPage.faq.a7.content')
                },
                {
                    title: this.$t('buddyPage.faq.a8.title'),
                    content: this.$t('buddyPage.faq.a8.content')
                },
                {
                    title: this.$t('buddyPage.faq.a9.title'),
                    content: this.$t('buddyPage.faq.a9.content')
                }
            ];
        }
    }
});
